package com.tovtalk.ui.platform

import androidx.compose.runtime.Composable

@Composable
actual fun rememberLocalVideoPreviewUri(bytes: ByteArray?, fileName: String?): String? = null
